// Autogenerated file
export const booksEditPermissionsFlagsEnum = {
    HasAccessToEditCars: "HasAccessToEditCars",
    HasAccessToEditDrivers: "HasAccessToEditDrivers",
    HasAccessToEditTrailers: "HasAccessToEditTrailers",
    HasAccessToEditCounterparties: "HasAccessToEditCounterparties",
    HasAccessToEditLegalPersons: "HasAccessToEditLegalPersons",
};
export const booksEditPermissionsFlags = [
    { label: "Машины", value: "HasAccessToEditCars", intValue: 1 },
    { label: "Водители", value: "HasAccessToEditDrivers", intValue: 2 },
    { label: "Прицепы", value: "HasAccessToEditTrailers", intValue: 4 },
    { label: "Контрагенты", value: "HasAccessToEditCounterparties", intValue: 8 },
    { label: "Юр. лица", value: "HasAccessToEditLegalPersons", intValue: 16 },
];
